import classNames from 'classnames'
import { forwardRef, InputHTMLAttributes } from 'react'

declare interface InputProps extends React.DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    textSize?: 'sm' | 'md' | 'lg'
    widthClasses?: string
    roundedClasses?: string
}

export const Input = forwardRef(({ children, className, textSize, widthClasses, roundedClasses, ...props }: InputProps, ref: React.LegacyRef<HTMLInputElement>) => {
    textSize = textSize || 'sm'
    widthClasses = widthClasses || 'w-full p-2.5'
    roundedClasses = roundedClasses || 'rounded-md'

    const componentClasses = classNames(
        roundedClasses,
        widthClasses,
        'border border-slate-300 dark:border-slate-800',
        'bg-slate-50 text-slate-900 dark:bg-slate-600 dark:text-slate-100',
        `text-${textSize}`,
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-usfGreen',
        'disabled:cursor-not-allowed disabled:bg-slate-200 disabled:dark:bg-slate-600 disabled:text-slate-500 disabled:dark:text-slate-300',
        className
    )

    return (
        <input className={componentClasses} {...props} ref={ref}>
            {children}
        </input>
    )
})
